import React, { useState } from 'react';
// @ts-ignore
import styles from './CustomSignature.module.scss';
import Button from '../../../../Components/Button/Button';
import apiClient from '../../../../Services/ApiClient';
import { useAppContext } from '../../../../Services/AppContext';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useRestApiClient from '../../../Base/Hooks/useRestApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import { useEffectAsync } from '../../../../helpers';
import Loading from '../../../../Components/Loading';
import { formatObjectForQuery } from '../../../../Services/Api/FormatObjectForQuery';
import ImageUpload from '../../../Base/Components/Inputs/ImageUploadField/ImageUpload';
import { getBase64AsFile } from '../../../Base/Helpers/image.helper';

interface Props {
	onSuccess: () => void;
}

const CustomSignature: React.FC<Props> = ({ onSuccess }) => {
	const { userData } = useAppContext();
	const { displayError } = useApiClient();
	const { showUnexpectedError } = useRestApiClient();
	const { showNotificationSuccess } = useNotification();
	const [isLoading, setIsLoading] = useState(false);
	const [image, setImage] = useState<string | undefined>(undefined);

	const handleSave = async () => {
		setIsLoading(true);
		if (image) {
			const file = await getBase64AsFile(image);
			// @ts-ignore
			const formData = new FormData();
			formData.append('file', file);
			try {
				const params = formatObjectForQuery({ custom: true });
				const response = await apiClient.postMultipart(
					`/doctors/${userData.id}/signature?${params}`,
					formData,
				);
				if (response.status === 200) {
					showNotificationSuccess({
						content: 'component.customSignature.successMessage',
					});
					onSuccess();
				} else {
					showUnexpectedError();
				}
			} catch (e) {
				displayError(e);
			}
		}
		setIsLoading(false);
	};

	function arrayBufferToBase64(buffer: ArrayBuffer) {
		let binary = '';
		const bytes = new Uint8Array(buffer);
		const len = bytes.byteLength;
		for (let i = 0; i < len; i++) {
			binary += String.fromCharCode(bytes[i]);
		}
		// @ts-ignore
		return window.btoa(binary);
	}

	useEffectAsync(async () => {
		setIsLoading(true);
		try {
			const response = await apiClient.get(
				`/doctors/${userData.id}/signature?custom=true`,
				{
					responseType: 'arraybuffer',
					catchError: false,
				},
			);
			if (response.status === 200) {
				const base64 = arrayBufferToBase64(response.data);
				setImage(`data:image/png;base64,${base64}`);
			}
		} catch (e: any) {
			if (e.response?.status !== 404) {
				displayError(e);
			}
		}
		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div>
			<ImageUpload onChange={image => setImage(image)} value={image} />
			<div className={styles.buttonWrapper}>
				<Button title='base.shared.save' onClick={handleSave} fitContent />
			</div>
		</div>
	);
};

export default CustomSignature;
